import { MutationTree } from 'vuex';
import { TemplatesState } from './types';

export const mutations: MutationTree<TemplatesState> = {
    setMailNotifyTemplates:(state, data) => {
        state.mailNotifyTemplates = data
    }
};
